<!--
// app/components/Shared/stats/GridFeaturedStatsTeamsOverview.vue
-->
<script setup lang="ts">
import type { SeasonStatsPartner } from "~/src/season-cluster/domain/models/01.Season";
import BaseBackdropLoading from "~/app/components/base/BaseBackdropLoading.vue";
import CardTeamRankingGeneralNoPartner from "~/app/components/pages/region-stats/cards-featured-stats/CardTeamRankingGeneralNoPartner.vue";
import { useWebContext } from "~/app/composables/webContext";

type Props = {
  loading: boolean;
  partner?: SeasonStatsPartner;
  seasonId?: number | string;
};
const props = defineProps<Props>();

const { locale, t } = useI18n();
const { isQueens } = useWebContext();

const preTitleGoals = computed(() => {
  if (isQueens) {
    return locale.value === "it" ? t("cards.stats.pretitle.best") : t("cards.stats.pretitle.top.team");
  } else {
    return locale.value === "it" ? t("cards.stats.pretitle.best") : t("cards.stats.pretitle.top");
  }
});
</script>

<template>
  <div class="text-gray-400 uppercase text-sm mb-2">{{ $t("general.stats.title") }}</div>
  <hr />
  <div class="main-container-cards">
    <base-backdrop-loading :active="loading"></base-backdrop-loading>

    <card-team-ranking-general-no-partner
      v-if="!!seasonId"
      :season-id="seasonId"
      page-stats-link="GoalsGrouped"
      :table-stat-title="$t('general.stats.goals')"
      parameter-string="GOL"
      :title-stat="isQueens ? $t('cards.stats.title.scorer.team') : $t('cards.stats.title.scorer')"
      :pre-title-stat="preTitleGoals"
      is-stats
    />

    <card-team-ranking-general-no-partner
      v-if="!!seasonId"
      :season-id="seasonId"
      page-stats-link="GoalsGrouped"
      parameter-string="GOL-S"
      sorted-ranking
      sort-order="DESC"
      order-by="ranking"
      :pre-title-stat="$t('cards.team.stats.pretitle.less')"
      :title-stat="$t('cards.team.stats.title.goaled')"
      :table-stat-title="$t('cards.team.stats.table.goalsConceded')"
      is-stats
    />

    <card-team-ranking-general-no-partner
      v-if="!!seasonId"
      :season-id="seasonId"
      parameter-string="XG"
      :pre-title-stat="$t('cards.team.stats.pretitle.expected')"
      :title-stat="$t('cards.team.stats.title.goals')"
      :table-stat-title="$t('general.stats.goals')"
      page-stats-link="Expected"
      is-stats
    />
  </div>
</template>

<style scoped>
.main-container-cards {
  @apply grid grid-cols-1 justify-items-center sm:grid-cols-2 md:grid-cols-3 gap-x-4 mt-4 relative;
}
</style>
